import { ImageIcon } from 'shared-widget-components/src/components/Icons';

export const WineLoadingSkeleton = () => {
  return (
    <div className='w-full lg:w-[450px] min-h-[300px] mb-4 relative px-4'>
      <div className='flex items-center justify-center w-full h-48 bg-gray-300 rounded'>
        <ImageIcon />
      </div>
      <div className='px-4 py-2 w-full'>
        <div className='h-3 w-52 bg-slate-200 rounded'></div>
        <div className='h-2 w-48 bg-slate-200 rounded mt-2'></div>
        <div className='h-2 w-44 bg-slate-200 rounded mt-1'></div>
        <div className='flex justify-between absolute bottom-2 w-full left-0 px-4'>
          <div className='h-3 w-20 bg-slate-200 rounded'></div>
        </div>
      </div>
    </div>
  );
};
